<template>
  <AppHeaderDropdown right no-caret>
    <template slot="header"> <i class="fa fa-lg fa-bars"></i> </template>\
    <template slot="dropdown">
      <!-- <b-dropdown-header tag="div" class="text-center">
        <strong class="text-capitalize">Hola {{ user }}</strong>
      </b-dropdown-header> -->
      <b-dropdown-item :href="baseUrlAdmin" target="_blank">Mantenedores</b-dropdown-item>
      <!-- Right aligned nav items -->
      <b-dropdown-item v-b-modal.modal-print>Imprimir etiquetas</b-dropdown-item>
      <b-dropdown-item @click.prevent="$router.push({ name: 'trazabilidad-buscar' })">Trazabilidad</b-dropdown-item>
      <b-dropdown-item
        @click.prevent="
          () => {
            $router.push({ name: 'historico-inicio' });
          }
        "
        >Histórico</b-dropdown-item
      >
      <b-dropdown-item
        @click.prevent="
          () => {
            $router.push({ name: 'descargar-datos' });
          }
        "
        >Descarga de datos</b-dropdown-item
      >
      <b-dropdown-item v-b-modal.modalPrevent>Cambiar contraseña</b-dropdown-item>
      <b-dropdown-divider />
      <b-dropdown-item v-on:click="salir"> <i class="fa fa-lock" />Cerrar sesión</b-dropdown-item>
    </template>
  </AppHeaderDropdown>
</template>

<script>
import { HeaderDropdown as AppHeaderDropdown } from "@coreui/vue";
import { mapState } from "vuex";

export default {
  name: "DefaultHeaderDropdownAccnt",
  components: {
    AppHeaderDropdown
  },
  data: () => {
    return {
      itemsCount: 42,
      nombreUsuario: "",
      name: "",
      names: []
    };
  },
  computed: {
    ...mapState({ user: (state) => state.user.USUARIO }),
    baseUrlAdmin() {
      return localStorage.getItem("packapp_api_url") + "/admin/";
    }
  },
  methods: {
    salir() {
      const self = this;
      this.$swal
        .fire({
          title: "¿Quieres salir?",
          text: "",
          type: "warning",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Si"
        })
        .then((result) => {
          if (result.value) {
            localStorage.removeItem("token");
            let resultado = delete self.$axios.defaults.headers.common["Authorization"];
            this.$store.dispatch("logout");
            this.$router.push("/pages/login");
          } else {
          }
        });
    },
    cambiarContrasena: function (e) {
      /*this.$refs.myModalRef.show();*/
      alert("Aqui");
    }
  },
  mounted() {
    this.nombreUsuario = this.$store.state.user.USUARIO;
  }
};
</script>
